<template>
  <div class="cont_main">
    <div class="container">
      <el-tabs v-model="message" @tab-click="handleClick">
        <el-tab-pane :label="`未读消息(${unread.length})`" name="first">
          <el-table  height="65vh" :data="unread" :show-header="false" style="width: 100%">
            <el-table-column label="标题" prop="title">
              <template v-slot="scope">
                <span class="message-title">{{ scope.row.title }}</span>
              </template>
            </el-table-column>
            <el-table-column label="内容" prop="content">
              <template v-slot="scope">
                <span class="message-title">{{ scope.row.content }}</span>
              </template>
            </el-table-column>
            <el-table-column label="时间" prop="sendTime" width="180" class-name="cell-two-line">
              <template v-slot="scope">
                <span class="message-title">{{
                  scope.row.sendTime | timestampToTime
                }}</span>
              </template>
            </el-table-column>
            <el-table-column width="120">
              <template v-slot="scope">
                <el-button size="small" @click="handleRead(scope.row)"
                  >标为已读</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="handle-row">
            <el-button type="primary" @click="handleAllRead()"
              >全部标为已读</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane :label="`已读消息(${read.length})`" name="second">
          <template v-if="message === 'second'">
            <el-table :data="read" height="65vh" :show-header="false" style="width: 100%">
              <el-table-column label="标题" prop="title">
                <template v-slot="scope">
                  <span class="message-title">{{ scope.row.title }}</span>
                </template>
              </el-table-column>
              <el-table-column label="内容" prop="content">
                <template v-slot="scope">
                  <span class="message-title">{{ scope.row.content }}</span>
                </template>
              </el-table-column>
              <el-table-column label="时间" prop="sendTime" width="180" class-name="cell-two-line">
                <template v-slot="scope">
                  <span class="message-title">{{
                    scope.row.sendTime | timestampToTime
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { pageCurrentUser, updateById, receiveBatch } from "@/api/chat";
import { EventBus } from "@/utils/event-bus.js";
export default {
  name: "tabs",
  data() {
    return {
      message: "first",
      showHeader: false,
      loading: false,
      unread: [],
      read: [],
      from: {
        limit: 999,
        page: 1,
        condition: {
          receiveStatus: false,
        },
        orders: [
          {
            asc: true,
            column: "createTime",
          },
        ],
      },
    };
  },
  async created() {
    this.getReadList();
    this.getUnreadList();
  },

  methods: {
    /** 查询未读消息列表 */
    async getUnreadList() {
      this.loading = true;
      this.from.condition.receiveStatus = false;
      let { data } = await pageCurrentUser(this.from);
      this.unread = data.records;
      this.$emit('chatInit',this.unread.length);
      this.loading = false;
    },
    /** 查询已读消息列表 */
    async getReadList() {
      this.loading = true;
      this.from.condition.receiveStatus = true;
      let { data } = await pageCurrentUser(this.from);
      this.read = data.records;
      this.loading = false;
    },
    //标签选择点击事件
    handleClick(tab) {
    },
    //全部标记已读
    async handleAllRead() {
      let { data } = await receiveBatch([]);
      this.getReadList();
      this.getUnreadList();
      EventBus.$emit('call-b-method');
      this.$message({
        type: 'success',
        message: '全部已读成功'
      });
    },
    //修改单条数据已读
    async handleRead(row) {
      let newArry = {
        id: row.id,
        receiveStatus: true,
      };
      let { data } = await updateById(newArry);
      this.getReadList();
      this.getUnreadList();
      EventBus.$emit('call-b-method');
      this.$message({
        type: 'success',
        message: "已读成功"
      });
      
    },
  },
  computed: {
    // unreadNum() {
    //   return this.unread.length;
    // },
  },
};
</script>

<style>
.cont_main {
  /* padding: 20px; */
}
.container {
  padding: 20px;
}
.message-title {
  cursor: pointer;
}
.handle-row {
  margin-top: 30px;
}
</style>

